import { css } from '@emotion/react';

const spacingToken = 'var(--fabric-space-gap-xxs)';

export const containerStyles = css`
  display: flex;
  align-items: center;
  gap: ${spacingToken};
`;

export const buttonStyles = css`
  display: flex;
  align-items: center;
  gap: ${spacingToken};
`;

export const selectedTextStyles = css`
  line-height: inherit;
`;
